import { TestimonialPropType } from "../../propTypes";

/**
 * Single testimonial display component showing customer quote, name, and country
 *
 * @component
 * @param {Object} props
 * @param {Object} props.testimonial - Testimonial data object
 * @param {string} props.testimonial.quote - Customer testimonial quote
 * @param {string} props.testimonial.author_name - Customer name
 * @param {string} props.testimonial.country - Customer country
 */
const Testimonial = ({ testimonial }) => {
  return (
    <div className="single-testimonial text-center">
      <p>{testimonial.quote}</p>
      <div className="client-info">
        <h5>{testimonial.author_name}</h5>
        <span>{testimonial.country}</span>
      </div>
    </div>
  );
};
Testimonial.propTypes = {
  testimonial: TestimonialPropType.isRequired,
};
export default Testimonial;
